module.exports = __webpack_public_path__ + "static/img/04923211.2ab2e431.png";